import React from 'react';
import AccountUpdateForm from 'components/Account/AccountUpdateForm/AccountUpdateForm';

const AccountUpdatePage: React.FC = () => {
  return <AccountUpdateForm data-testId="account-update-form" />;
};

export default AccountUpdatePage;
